'use client';

import Cookies from 'js-cookie';
import {
  ATTR_COOKIE_DAYS,
  ATTR_COOKIE_NAME,
  LEGACY_COOKIE_NAME,
  classifyTouch,
  decodeAttribution,
  encodeAttribution,
  mergeTouch,
  parseLegacyUtm,
} from './attribution';

/**
 * Записывает касание текущей страницы в cookie.
 *
 * Прямой заход и внутренние переходы cookie не меняют — сохранённый рекламный
 * источник остаётся нетронутым (правило last non-direct click).
 */
export function recordTouch(): void {
  if (typeof window === 'undefined') return;

  try {
    const stored = decodeAttribution(Cookies.get(ATTR_COOKIE_NAME));
    const legacyRaw = Cookies.get(LEGACY_COOKIE_NAME);
    const prev = stored || (legacyRaw ? parseLegacyUtm(legacyRaw) : null);

    const params = new URLSearchParams(window.location.search);
    const touch = classifyTouch({
      url: window.location.href,
      referrer: document.referrer || '',
      host: window.location.hostname,
    });

    // Писать нечего: касания нет, а актуальная cookie уже на месте.
    if (!touch && stored) return;
    if (!touch && !prev) return;

    const next = mergeTouch(prev, touch, {
      yclid: params.get('yclid') || '',
      ysclid: params.get('ysclid') || '',
    });

    Cookies.set(ATTR_COOKIE_NAME, encodeAttribution(next), {
      expires: ATTR_COOKIE_DAYS,
      sameSite: 'Lax',
      secure: window.location.protocol === 'https:',
      path: '/',
    });

    // Старая cookie перенесена — гасим, чтобы не возить оба формата в каждом запросе.
    if (legacyRaw) {
      Cookies.remove(LEGACY_COOKIE_NAME, { path: '/' });
    }
  } catch {
    // Атрибуция никогда не должна ломать страницу.
  }
}
